import Manipulator from '../../utils/dom/manipulator';
import BaseComponent from '../BaseComponent';
const NAME = 'Accordion';
import dataLayer from '../../utils/data-layer';
class Accordion extends BaseComponent {
	constructor(element) {
		super(element);
		this.init();
	}
	static get NAME() {
		return NAME;
	}
	init() {
		const accordion = this._element;
		const multipleSelect = accordion.classList.contains('lta-accordion__multiple');
		const accordionItems = accordion.querySelectorAll('.lta-accordion--item');
		const triggers = Array.prototype.slice.call(accordion.querySelectorAll('.lta-accordion--trigger'));

		accordionItems.forEach((item) => {
			const itemCta = item.querySelector('.lta-accordion--trigger');

			itemCta.addEventListener('click', (event) => {
				const target = event.currentTarget;
				const isOpen = target.getAttribute('aria-expanded') == 'true';
				const active = multipleSelect
					? accordion.querySelectorAll('[aria-expanded="true"]')
					: accordion.querySelector('[aria-expanded="true"]');
				const targetPanel = target.getAttribute('aria-controls');
				const targetTitle = target.querySelector('.lta-accordion--title').innerText;

				if (!multipleSelect && active && active !== target) {
					active.setAttribute('aria-expanded', 'false');
					const activePanel = active.getAttribute('aria-controls');
					accordion.querySelector(`#${activePanel}`).setAttribute('hidden', '');
				}

				if (!isOpen) {
					// If the target has data-accordion-collapse it will collapse all the others Items opens.
					if (Manipulator.getDataAttribute(target, 'accordion-collapse') && active.length > 0) {
						active.forEach((current) => {
							const activePanel = current.getAttribute('aria-controls');
							current.setAttribute('aria-expanded', 'false');
							accordion.querySelector(`#${activePanel}`).setAttribute('hidden', '');
						});
					}

					target.setAttribute('aria-expanded', 'true');
					accordion.querySelector(`#${targetPanel}`).removeAttribute('hidden');
					try { // Pushing the info to datalayer when the accordion is opened for SEO to track the user interaction.
						dataLayer.push({
							event: 'select_content',
							content_type : 'accordion',
							item_id: targetTitle,
							action: 'open'
						});
					} catch (error) {
						console.log(error.message);
					}
				} else if (isOpen) {
					target.setAttribute('aria-expanded', 'false');
					accordion.querySelector(`#${targetPanel}`).setAttribute('hidden', '');
				}
			});
		});

		accordion.addEventListener('keydown', function (event) {
			const { target, key } = event;

			const ctrlModifier = key === 'Control' && (key === 'PageUp' || key === 'PageDown');

			if (target.classList.contains('lta-accordion--trigger')) {
				if (key === 'ArrowDown' || key === 'ArrowUp' || ctrlModifier) {
					const index = triggers.indexOf(target);
					const direction = key === 'PageDown' || key === 'ArrowDown' ? 1 : -1;
					const length = triggers.length;
					const newIndex = (index + length + direction) % length;

					triggers[newIndex].focus();
				} else if (key === 'End' || key === 'Home') {
					switch (key) {
						case 'Home':
							triggers[0].focus();
							break;
						case 'End':
							triggers[triggers.length - 1].focus();
							break;
						default:
							break;
					}
				}
			}
		});
	}
}

export default Accordion;
